import script from "./CustomerInfoView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerInfoView.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerInfoView.vue?vue&type=style&index=0&id=42959550&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42959550"]])

export default __exports__